<db-dialog-wrapper [dialog]="this" [width]="'500px'" [height]="'200px'">
  <div class="db-reset-password-success">
    <div>
      <form >
        <h2>{{'text_checkYourEmail' | dbText}}</h2>
        <p>{{'text_checkYourEmailDesc' | dbText}}</p>
        <div class="db-buttons">
          <a class="ds-btn ds-btn-m ds-btn-blue" (click)="closeDialog()"><span>{{'text_ok' | dbText}}</span></a>
        </div>
      </form>
    </div>
  </div>
</db-dialog-wrapper>
